module.exports = "/assets/5ad69adac8def2c7b58132ef88c776d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VX.png
// module id = 1942
// module chunks = 0